import React from 'react';
import PropTypes from 'prop-types';
import {Container, Content, SectionPlaceholder} from '../../../../../shared/library/cards/card';
import sanitizeData from './../../../../../shared/utils/sanitize-data';

const ComparisonCard = ({content}) => {
  return (
    <Container>
      {content !== '' && (
        <Content
          dangerouslySetInnerHTML={{
            __html: sanitizeData(content)
          }}
        />
      )}
      {content === '' && <SectionPlaceholder>No comparison data found</SectionPlaceholder>}
    </Container>
  );
};

ComparisonCard.propTypes = {
  content: PropTypes.string
};

export default ComparisonCard;
